// extracted by mini-css-extract-plugin
module.exports = {"SKinoklubb":"Kinoklubb_SKinoklubb__iFb3e","SKinoklubbLink":"Kinoklubb_SKinoklubbLink__Aluox"};